export default __webpack_public_path__ + "static/media/metaforce.eec4d7b7.jpg";